var api = "https://api.qingcigame.com";
var initialSlide = 0;

// 部分文章添加下载按钮跳转功能
let jsonDataId = [{
        id: 599,
        picture: 'https://download4.qcplay.com/qcgame-admin/3NnBlizsuly5G0LI7NpBj4KptBs5KWl3av0KCrUX.png',
        downloadBtn: 'https://download4.qcplay.com/qcgame-admin/fESWYDdnz7anFUL0coVDKX7lR42bjAbakt24S6de.png',
        downloadUrl: '//download2.qcplay.com/zd/apk/launcher-release.apk',
    },
    // {
    //     id: 600,
    //     picture: 'https://download4.qcplay.com/qcgame-admin/3NnBlizsuly5G0LI7NpBj4KptBs5KWl3av0KCrUX.png',
    //     downloadBtn: 'https://download4.qcplay.com/qcgame-admin/fESWYDdnz7anFUL0coVDKX7lR42bjAbakt24S6de.png',
    //     downloadUrl: 'http://download2.qcplay.com/zd/apk/launcher-release.apk',
    // }
]


var obj = {
    init: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                }
            }
        };
        getRequest();
        this.swiper(); // swiper轮播
        this.share();
        this.indexBind();
        this.textLength();
        this.downloadBind();
        this.onAdaptive();
        const that = this;
        $(window).on('resize', function() { that.onAdaptive(); });
    },
    newsList: function() {
        var cate_id, page, current, index, urls;
        urls = 'https://api.qcplay.com/web/article'; // 第一页
        area = 4;
        this.newsZxList(urls, area); // 新闻最新列表
        this.newsTabPage(); // 最新、综合、活动跳转
        this.hiddenNav(); // 头部隐藏导航
        this.share();
        this.downloadBind();
    },
    // 根据宽高比做自适应
    onAdaptive: function() {
        const width = $(window).width();
        const height = $(window).height();
        const proportion = width / height;

        if (proportion >= 0.585) {
            $('.car-container').css('transform', 'scale(0.4)')
        } else if (proportion >= 0.56) {
            $('.car-container').css('transform', 'scale(0.415)')
        } else if (proportion >= 0.462) {
            $('.car-container').css('transform', 'scale(0.42)')
        } else {
            $('.car-container').css('transform', 'scale(0.425)')
        }
    },
    // 新闻详情
    newsDetails: function() {
        this.newsInfo(); // 新闻详情
        this.hiddenNav(); // 头部隐藏导航
        this.share();
        this.downloadBind();
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
            // console.log(numbers);

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').removeClass('landing');
            setTimeout(function() {
                // $('.preloading').remove();
                obj.swiper();
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '//static.qcplay.com/snail/charity/images/mobile/m_jdt.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_dt_t.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_dt_sz.png',
            '//static.qcplay.com/snail/charity/images/mobile/fn.png',
            '//static.qcplay.com/snail/charity/images/mobile/hb.png',
            '//static.qcplay.com/snail/charity/images/mobile/pd.png',
            '//static.qcplay.com/snail/charity/images/mobile/role_01_img.png',
            '//static.qcplay.com/snail/charity/images/mobile/role_02.png',
            '//static.qcplay.com/snail/charity/images/mobile/role_03.png',
            '//static.qcplay.com/snail/charity/images/mobile/role_04.png',
            '//static.qcplay.com/snail/charity/images/mobile/role_05.png',
            '//static.qcplay.com/snail/charity/images/mobile/yun_01.png',
            '//static.qcplay.com/snail/charity/images/mobile/yun_02.png',
            '//static.qcplay.com/snail/charity/images/mobile/yun_03.png',
            '//static.qcplay.com/snail/charity/images/mobile/yun_04.png',
            '//static.qcplay.com/snail/charity/images/mobile/yun_05.png',
            '//static.qcplay.com/snail/charity/images/mobile/yun_06.png',
            '//static.qcplay.com/snail/charity/images/mobile/zsj.png',
            '//static.qcplay.com/snail/charity/images/mobile/act_dec_bg.png',
            '//static.qcplay.com/snail/charity/images/mobile/act_dec_bg_2.png',
            '//static.qcplay.com/snail/charity/images/mobile/arrow_l.png',
            '//static.qcplay.com/snail/charity/images/mobile/arrow_r.png',
            '//static.qcplay.com/snail/charity/images/mobile/btn_down_01.png',
            '//static.qcplay.com/snail/charity/images/mobile/btn_on.png',
            '//static.qcplay.com/snail/charity/images/mobile/close_btn.png',
            '//static.qcplay.com/snail/charity/images/mobile/header_bg.png',
            '//static.qcplay.com/snail/charity/images/mobile/inf_bg_00.png',
            '//static.qcplay.com/snail/charity/images/mobile/inf_bg_01.png',
            '//static.qcplay.com/snail/charity/images/mobile/inf_bg_03.png',
            '//static.qcplay.com/snail/charity/images/mobile/logo_img.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_conten_banner_01.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_conten_banner_02.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_conten_banner_02.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_conten_banner_03.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_content_title_02.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_content_title_03.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_content_title_04.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_index_01.jpg',
            '//static.qcplay.com/snail/charity/images/mobile/m_index_01.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_index_03_buttom.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_off.png',
            '//static.qcplay.com/snail/charity/images/mobile/m_title.png'

        ]);
    },
    swiper: function() {
        function pageSwiper() {
            var mySwiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                spaceBetween: 0,
                initialSlide: initialSlide,
                effect: 'fade',
                onInit: function(swiper) { //Swiper2.x的初始化是onFirstInit
                    swiperAnimateCache(swiper); //隐藏动画元素 
                    swiperAnimate(swiper); //初始化完成开始动画
                },
                onSlideChangeStart: function(swiper1) {
                    if (swiper1.activeIndex === 0) {
                        // $('.cloud-01').addClass('cloud-ani-01')
                        $(".swiper-wrapper").css("z-index", "11")
                            // $(".swiper-button-next, .swiper-button-prev").hide()
                    } else {
                        // $('.cloud-01').addClass('cloud-ani-01')
                        $(".swiper-wrapper").css("z-index", "0")
                            // $(".swiper-button-next, .swiper-button-prev").show();
                    }
                },
                onSlideChangeEnd: function(swiper) {
                    //每个slide切换结束时也运行当前slide动画
                    swiperAnimate(swiper);
                    // if (swiper.activeIndex !== 0) {
                    //     $('.cloud-01').addClass('cloud-ani-01')
                    // }
                    for (var i = 1; i < 5; i++) { $('.swiper-wrapper').removeClass('wrapper-bg-0' + i + '') };
                    var index = swiper.activeIndex + 1;
                    $('.swiper-wrapper').addClass('wrapper-bg-0' + index + '');
                },
            });

            $('.link_btn').on('click', function() {
                let data = $(this).attr('data')
                $('.cloud-01').addClass('cloud-ani-01')
                mySwiper.slideTo(data, 300);
            })
        }
        pageSwiper();
    },
    // 所有绑定事件
    indexBind: function() {
        //适龄弹窗
        $('.year_box').on('click', function(event) {
            $('.year_pop').fadeIn();
        });
        $('.close-btn').click(function(event) {
            $('.year_pop').fadeOut();
        });
        $('.swiper-button-prev').click(function() {
            $('.cloud-01').removeClass('cloud-ani-01')
        });
    },
    // 下载
    downloadBind: function() {
        // 关闭下载提示
        $('.download-wrap').on('click', function() {
            $(this).fadeOut();
        });

        $('.download-btn').click(function(event) {
            console.log(111);
            var jump = window.location.href;
            var game_id = 39;
            $.ajax({
                type: "get",
                url: 'https://mapi.qingcigame.com/get_url?game_id=' + game_id + '',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    console.log(json);
                    // 微信
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        $('.download-wrap').fadeIn();
                        return
                    };
                    //安卓
                    if (/(Android)/i.test(navigator.userAgent)) {
                        if (jump.indexOf('04') !== -1) {
                            location.href = 'https://download4.qcplay.com/apk/qc-kol-880359.apk'
                        } else {
                            if (json.data.android_download_url == '') {
                                layer.msg('安卓下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', { time: 3000 });
                            } else {
                                location.href = json.data.android_down_url
                                console.log(json.data.android_down_url);
                            }
                        }
                    };
                    //ios
                    if (/(iphone)/i.test(navigator.userAgent)) {
                        if (json.data.ios_download_url == '') {
                            layer.msg('ios下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', { time: 3000 });
                        } else {
                            location.href = json.data.ios_down_url
                            console.log(json.data.ios_down_url);
                        }
                    };
                }
            });
        });
    },
    // 新闻列表接口
    newsZxList: function(urls, area) {
        cate_id = this.getQueryVariable('cate_id');
        page = this.getQueryVariable('page');
        current = window.location.href.split("?")[0];
        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + cate_id + '').addClass('on').siblings().removeClass('on');

        function newsAjax(urls) {
            $.ajax({
                url: urls,
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    // area    4...
                    cate_id: cate_id,
                    page: page,
                    area: area
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var current_page = json.data.articleList.current_page; // 当前页数
                        var last_page = json.data.articleList.last_page; // 总共页数
                        var next_page_url = json.data.articleList.next_page_url; // 后一页
                        //
                        // 渲染列表
                        $.each(json.data.articleList.data, function(index, values) {
                            var dtHtml = `<li>
                                    <a title="${values.article_title}" href="news-details-mobile.html?id=${values.id}">
                                        <div class="news-image">
                                            <img src=" ${values.move_thumbnail}">
                                        </div>
                                        <div class="text-box">
                                            <h2>${values.article_title}</h2>
                                            <p>${values.article_excerpt}</p>
                                        </div>
                                    </a>
                                </li>`;
                            $('.list-wrap ul').append(dtHtml);
                        });
                        obj.textLength(49, 22);
                        $('.current_page').html(current_page); // 当前页数
                        $('.last_page').html(last_page); // 总共页数
                        if (next_page_url === null) { // 下一页
                            $('.more-btn a').attr('data', '').html('已经没有了'); // 没有最后一页
                        } else {
                            $('.more-btn a').attr('data', next_page_url);
                        }
                    } else {
                        layer.msg("服务器请求失败", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("服务器请求失败", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            if ($(this).attr('data') == '') {
                layer.msg("已经没有了", { time: 2000 });
            } else {
                urls = $(this).attr('data');
                page++
                newsAjax(urls);
            }
        });
        for (var i = $('.link-box-02 div a').length; i >= 1; i--) {
            if (cate_id == i) $('.link-box-02 div a:nth-child(' + i + ')').addClass('on');
        };
    },
    // 内容字体长度超过40，标题字体长度超过25
    textLength: function(x1, x2) {
        $('.new-list p').each(function() {
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.new-list h2').each(function() {
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },

    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?cate_id=' + cate_id + '&page=1'
        });


        cate_id = this.getQueryVariable('cate_id');
        if (cate_id == 37) $('.li-tab-01').addClass('on').siblings().removeClass('on');
        if (cate_id == 38) $('.li-tab-02').addClass('on').siblings().removeClass('on');
        if (cate_id == 39) $('.li-tab-03').addClass('on').siblings().removeClass('on');
        if (cate_id == 43) $('.li-tab-04').addClass('on').siblings().removeClass('on');
        if (cate_id == 41) $('.li-tab-05').addClass('on').siblings().removeClass('on');
        if (cate_id == 42) $('.li-tab-06').addClass('on').siblings().removeClass('on');
        if (cate_id == 48) $('.li-tab-05').addClass('on').siblings().removeClass('on');
    },
    // 新闻详情
    newsInfo: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        filterData = jsonDataId.filter(item => item.id == id);
        // console.log(filterData);
        if (filterData.length !== 0) {
            var dlPic = filterData[0].picture;
            var dlBtn = filterData[0].downloadBtn;
            var dlUrl = filterData[0].downloadUrl;
            $('.news-details .news-dl-image').show().css('background-image', dlPic);
            $('.news-details .news-dl-box').show().css('background-image', dlBtn);
            $('.news-details .news-download-btn').attr('href', dlUrl);
        }
        $.ajax({
            url: "https://api.qcplay.com/web/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                $('.news-det .main').addClass('main-show');
                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    $('.news-title, .current-title').html(newsTitle);
                    $('.details-info').append(detailsInfo);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');
                } else {
                    layer.msg("服务器请求失败", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("服务器请求失败", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?' + cite + '='
            // console.log(href)
            // console.log(lastPage);
            // console.log(nextPage);

        if (lastPage !== '') $('.prev-page').addClass('show').attr('href', href + lastPage.id).attr('title', lastPage.article_title);
        if (nextPage !== '') $('.next-page').addClass('show').attr('href', href + nextPage.id).attr('title', nextPage.article_title);
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    // 隐藏导航
    hiddenNav: function() {
        // 隐藏导航
        var change = true;
        $('.navBox').on('click', '.nav_more', function() {
            if (change == true) {
                $('.nav_more').addClass('change');
                $('.nav-popup').addClass('nav-popup-show');
                change = false;
            } else {
                $('.nav_more').removeClass('change');
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            }
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '最强蜗牛', // 分享标题
                            desc: '公益活动', // 分享描述
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '最强蜗牛-公益活动', // 分享标题
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '最强蜗牛', // 分享标题
                            summary: '公益活动', // 分享内容
                            pic: 'https://static.qcplay.com/common/snail_icon.png', // 分享图片
                            url: window.location.href, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },
}